<template>
	<div v-if="$store.state.loading" id="loading">
		<div class="outsideDiv">
			<div class="loader"></div>
			<div class="insideDiv">{{ $t("components.kLoading.message") }}</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#loading {
	background-color: #000000;
	opacity: 0.7;
	color: white;
	font-size: 32px;
	height: 100vh;
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999999;
	display: flex;
	justify-content: center;
	align-items: center;
}
.outsideDiv {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.loader {
	border: 2px solid #f3f3f3;
	border-top: 4px solid #000000;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	-webkit-animation: spin 2s linear infinite;
	animation: spin 2s linear infinite;
	margin-bottom: 16px;
}
.insideDiv {
	font-size: 25px;
	text-align: center;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
